import React, {CSSProperties} from "react";
import classNames from "classnames";
import {isChristmas} from "../../utils/other";

const ROUND_PRECISION = 1000;

function getPercentage(now: number, min: number, max: number) {
    let percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

export type ProgressBarPropsType = {
    min: number,
    max: number,
    striped?: boolean,
    animated?: boolean,
    srOnly?: boolean,
    label?: any,
    style?: CSSProperties,
} & ({now: number} | {progress: number});

export default class ProgressBar extends React.Component<ProgressBarPropsType> {
    render() {
        const isItChristmas = isChristmas(true);
        const percent = Math.min(getPercentage((this.props as any).now !== undefined ? (this.props as any).now : (this.props as any).progress, this.props.min, this.props.max), 100);
        return (
            <div className={classNames("progress", {"christmas": isItChristmas})}>
                <div className={classNames("progress-bar", {
                    "progress-bar-striped": !!this.props.striped || isItChristmas,
                    "progress-bar-animated": !!this.props.animated || isItChristmas,
                })}
                     style={{width: percent + "%", ...(this.props.style || {})}}>
                    {this.props.children}
                    {percent > 0 && <span className={classNames({"sr-only": this.props.srOnly})}>{this.props.label}</span>}
                    {percent > 0 && isItChristmas ? <div className="santa">
                        <div className="body">
                            <div className="head">
                                <div className="ear"/>
                                <div className="ear"/>
                                <div className="hat"/>
                                <div className="eye"/>
                                <div className="eye"/>
                                <div className="nose"/>
                                <div className="mouth"/>
                            </div>
                        </div>
                    </div> : null}
                </div>
            </div>
        );
    }
}